const validator = () => {

    $('.validator').click(e => {
        var error = document.getElementsByClassName('validation');
        var i;
        for (i = 0; i < error.length; i++) {
            if (window.getComputedStyle(error[i]).display != "none") {
                error[i].scrollIntoView({ block: "center" });
            }
        }
    })

};

export {
    validator
};
